import Translate, { Message } from "../messages/GeralMessages";

export function HandleErrors(err) {
  if (err.response === undefined) {
    return Translate(Message.Unknown);
  } else if (err.response.status === 500) {
    return Translate(Message.Internal);
  } else if (err.response.status === 400) {
    let message = "";
    for (let s in err.response.data) {
      const item = err.response.data[s];
      console.log("tratamento", item);
      for (let i in item) {
        const error = item[i];
        console.log("resultado", error);

        message += error;
      }
    }
    return message;
    return `Ocorreu o seguinte erro : ${err.response.data}`;
  } else if (err.response.status === 401) {
    return Translate(Message.Prohibited);
  } else if (err.response.status === 403) {
    return Translate(Message.Prohibited);
  } else if (err.response.status === 404) {
    return Translate(Message.DontExist);
  } else if (err.response.status === 408) {
    return Translate(Message.Limit);
  } else if (err.response.status === 409) {
    return Translate(Message.Conflict);
  } else if (err.response.status === 413 || err.response.status === 414) {
    return Translate(Message.Largest);
  } else if (err.response.status === 415) {
    return Translate(Message.Unsuported);
  } else {
    return Translate(Message.Unknown);
  }
}

export function HandleAuthErrors(err) {
  if (err.response === undefined) {
    return Translate(Message.Unknown);
  } else if (err.status === 500 || err.response.status === 500) {
    return Translate(Message.Internal);
  } else if (err.response.status === 400) {
    let message = "";
    for (let s in err.response.data) {
      const item = err.response.data[s];
      for (let i in item) {
        const error = item[i];
        if (error.code == "DuplicateUserName") {
          message += Translate(Message.Login.AlreadyExist);
        }
      }
    }
    return message;
  } else if (err.response.status === 401) {
    return Translate(Message.Login.Incorrect);
  } else if (err.response.status === 403) {
    return Translate(Message.Prohibited);
  } else if (err.response.status === 404) {
    return Translate(Message.Login.DontExist);
  } else if (err.response.status === 409) {
    return Translate(Message.Login.AlreadyExist);
  } else if (err.response.status === 408) {
    return Translate(Message.Limit);
  } else {
    return Translate(Message.Unknown);
  }
}
